/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 24/7/2024
 */

import { Grid, Typography } from "@mui/material";
import React from "react";
import styles from "./RequestList.module.css";

const CardText = ({ request }) => {
  return (
    <div className={styles.cardText}>
      <div className={styles.textContainer}>
        <div className={styles.headerContainer}>
          <Typography variant="h6" className={styles.text1}>
            {request.catName}{" "}
            {request.freqName && <label>({request.freqName})</label>}
            {request.resourceId == 0 && (
            <label style={{ marginLeft: "auto", fontWeight: 200, fontSize: "16px" }}> - {request.resourceName} </label>
            )}
          </Typography>
        </div>

        <Grid container spacing={2} className={styles.row}>
          <Grid item md={4} sm={12}>
            <Typography variant="subtitle1" className={styles.text2t}>
              Address:
            </Typography>
            <Typography variant="subtitle1" className={styles.text2}>
              {request.addressLine1 ? request.addressLine1 : ""}
              {request.addressLine1 ? ", " : ""}
              {request.addressLine2 ? request.addressLine2 : ""}
              {request.addressLine2 ? ", " : ""}
              {request.addressLine3 ? request.addressLine3 : ""}
              {request.addressLine3 ? ", " : ""}
              {request.areaName ? request.areaName : ""}
              {request.areaName ? ", " : ""}
              {request.stateName ? request.stateName : ""}{" "}
            </Typography>
          </Grid>
          <Grid item md={4} sm={12}>
            <Typography variant="subtitle1" className={styles.text2t}>
              Date:
            </Typography>
            <Typography variant="subtitle1" className={styles.text2}>
              {`${request.day} (${request.timeSlot})`}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default CardText;
